module.exports = __webpack_public_path__ + "img/South Asian Games.a4c0c146.jpg";